common.View.create('shop::Habitats.Website.Modules.ShopProducts.Index.Filters', {

    setByUrl()
    {
        // Update each filter.
        for(let filterElement of this.element.find('.filter'))
            $(filterElement).data('instance').setByUrl();
    },

    getIndexInstance()
    {
        return shop.Habitats.Website.Modules.ShopProducts.Index.getInstance(this);
    },

    onUserInput()
    {
        this.getIndexInstance().onUserInput();
    },

    getFilterQuery()
    {
        let result = {};

        // Add store filter?
        if(this.element.data('store-id'))
            result['store'] = this.element.data('store-id');

        // Loop filters.
        for(let filterElement of this.element.find('.responsiveFilters:visible .filter'))
            result = {
                ...result,
                ...$(filterElement).data('instance').getFilterQuery() || {},
            };

        // Show remove filters?
        if( !$.isEmptyObject(result) )
            this.element.find('.removeFilters').removeClass('tw-hidden');
        else
            this.element.find('.removeFilters').addClass('tw-hidden');

        //
        return result;
    },

    updateHtml(ajaxResponse)
    {
        // Get new filters.
        let newFilters = ajaxResponse.find('.shop\\:\\:Habitats-Website-Modules-ShopProducts-Index-Filters .filter');

        // Delegate to each filter.
        for(let filterElement of this.element.find('.filter'))
        {
            // Get instance.
            let instance = $(filterElement).data('instance');

            // Get new filter HTML.
            let newFilterHtml = newFilters.filter('[data-filter-slug="' + instance.getFilterSlug() + '"]');

            // Delegate to filter. Use html of the first element (probarly the mobile filter) which is (now) the same as the desktop version.
            instance.setByHtml(newFilterHtml.get(0).outerHTML);
        }
    },

});
